export default function validate (values) {
  const errors = {}

  if (!values.activityType) {
    errors.activityType = 'activityType/invalid'
  }

  if (!values.startDate || (typeof values.startDate.format !== 'function')) {
    errors.startDate = 'startDate/invalid'
  }

  if (values.startTime && (typeof values.startTime.format !== 'function')) {
    errors.startTime = 'startTime/invalid'
  }

  return errors
}



// WEBPACK FOOTER //
// ./src/components/workouts/WorkoutForm/validate.js